module.exports = __webpack_public_path__ + "img/logo.71bd9998.png";